
<div class="wrap-text">
  <span v-if="isTypeIndividual">
    {{ client.firstName }} {{ client.lastName }} | {{ client.code }}
  </span>
  <span v-else>
    {{ client.legalName }} | {{ client.code }}
  </span>
</div>
